import { useEffect } from 'react'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import CreateWorkspacePage from '@/pages/CreateWorkspace/CreateWorkspacePage'
import WorkspacePickerPage from '@/pages/CreateWorkspace/WorkspacePickerPage'
import WorkspaceGateError from '@/routes/WorkspaceGateError.jsx'
import { syncActiveWorkspace, useWorkspaces } from '@/hooks/useWorkspaces'
import { useWorkspaceStore } from '@/store/workspaceStore'

/** @param {{ children: import('react').ReactNode }} props */
export default function RequireWorkspace({ children }) {
  const query = useWorkspaces()
  const activeWorkspaceId = useWorkspaceStore((state) => state.activeWorkspaceId)

  useEffect(() => {
    if (query.isSuccess) syncActiveWorkspace(query.data?.workspaces ?? [])
  }, [query.data, query.isSuccess])

  if (query.isLoading || (query.isFetching && !query.data)) return <RouteSuspenseFallback />
  if (query.isError) return <WorkspaceGateError onRetry={() => void query.refetch()} />
  const workspaces = query.data?.workspaces ?? []
  if (!workspaces.length) return <CreateWorkspacePage />
  if (!workspaces.some((workspace) => workspace.id === activeWorkspaceId)) {
    return <WorkspacePickerPage workspaces={workspaces} />
  }
  return children
}
